<template>
  <div>
    <div
      class="-mb-px mb-4 flex justify-between space-x-8"
      aria-label="Tabs"
    >
      <button
        v-for="tab in tabs"
        :key="tab.value"
        :class="[
          tab.value === modelValue
            ? 'border-primary text-primary'
            : 'text-background-fg/50 hover:border-background-fg/70 hover:text-background-fg/70 border-transparent',
          'flex-grow whitespace-nowrap border-b-2 px-1 py-4 text-sm font-semibold',
        ]"
        @click="emit('update:modelValue', tab.value)"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
export type TabOption = {
  value: string
  label: string
}

defineProps<{
  modelValue: string
  tabs: Array<TabOption>
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: string): void
}>()
</script>
